let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jtxFc")).then(() => parcelRequire('dLoPa'));